<template>
    <div class="credit-card-view">
        <div class="cc-inner">
            <card-creator ref="cardCreator" @success="onCreateSuccess" @error="onCreateError"/>

            <div class="cc-error">
                <v-icon size="18" color="error">mdi-alert-circle-outline</v-icon>
                <div class="cc-error-text" v-html="currentError"/>
            </div>

            <div class="cc-logout">
                <logout-button small outlined/>
            </div>
        </div>
    </div>
</template>

<script>
import CardCreator from "@/components/common/payment/CardCreator";
import LogoutButton from "@/components/common/inputs/LogoutButton";
import {mapActions} from "vuex";

export default {
    name: "CreditCard",
    components: {LogoutButton, CardCreator},
    computed: {
        paymentMethodDeleted(vm = this) {
            return vm.$route.query.deleted === 'true'
        },
        currentError(vm = this) {
            if (vm.paymentMethodDeleted) return vm.$t('coach.payment_method_declined')
            let last4 = vm.account?.stripeAccount?.last4 || null
            let defaultMessage = vm.$t('payment_failed_messages.try_again_later')
            let failedReason = vm.account?.stripeAccount?.failedReason || null
            let reason = vm.$te(`payment_failed_messages.${failedReason}`) ?
                vm.$t(`payment_failed_messages.${failedReason}`) : defaultMessage
            if (last4) return vm.$t('payment_failed_messages.last_card', {last4}) + '<br>' + reason
            return vm.$t('coach.payment_method_required')
        },
    },
    methods: {
        ...mapActions(['bindUserAccount']),
        async onCreateSuccess() {
            const vm = this

            if (vm.account) {
                await vm.bindUserAccount(vm.currentUser)

                if (!vm.account?.stripeAccount?.currentSubscription?.id)
                    await vm.pushRoute({name: `${vm.accountType}.select-plan`})
            }
        },
        onCreateError(error) {
            console.log('error', error)
        }
    },
}
</script>

<style scoped>

.credit-card-view {
    padding: 24px 0;
}

.cc-inner {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 480px;
    margin: 0 auto;
}

.cc-error {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    border-radius: 12px;
    border: 1px solid var(--v-error-base);
    background: rgba(255, 82, 82, 0.08);
}

.cc-error-text {
    font-size: var(--fs-body);
    line-height: 1.45;
    color: var(--v-txtSecondary-base);
}

.cc-logout {
    text-align: center;
}

</style>
